import {css} from 'styled-components';

/** Consistent box sizing to help composer details labels and tokens line up. */
export const composerDetailsTokenBoxStyle = css`
  line-height: 20px;
  padding-top: 1px;
  padding-bottom: 1px;
  margin-top: 2px;
  margin-bottom: 2px;
`;
